import type { SourceSnapshot, DisplayMode } from "@tuit/shared-types";
import { SectionView } from "./SectionView";
import { SourcePicturesView } from "./SourcePicturesView";
import { SourceGalleryView } from "./SourceGalleryView";

const EMPTY_SET = new Set<string>();
const EMPTY_MAP = new Map<string, string[]>();
const noop = () => {};
const noopRef = () => {};

interface Props {
  section: SourceSnapshot;
  // Overrides section.displayMode when provided (e.g. editor live-preview)
  displayMode?: DisplayMode;
  // SectionView props — all optional, no-op when omitted
  readIds?: Set<string>;
  onRead?: (id: string) => void;
  suppressed?: Set<string>;
  alsoIn?: Map<string, string[]>;
  sectionRef?: (el: HTMLElement | null) => void;
  highlight?: string;
  mobile?: boolean;
}

export function SourcePanel({
  section,
  displayMode,
  readIds = EMPTY_SET,
  onRead = noop,
  suppressed = EMPTY_SET,
  alsoIn = EMPTY_MAP,
  sectionRef = noopRef,
  highlight,
  mobile = false,
}: Props) {
  const mode = displayMode ?? section.displayMode ?? "text";

  if (mode === "picture") return <SourcePicturesView snapshot={section} readIds={readIds} onRead={onRead} mobile={mobile} />;
  if (mode === "gallery") return <SourceGalleryView snapshot={section} />;
  return (
    <SectionView
      section={section}
      readIds={readIds}
      onRead={onRead}
      suppressed={suppressed}
      alsoIn={alsoIn}
      sectionRef={sectionRef}
      highlight={highlight}
      mobile={mobile}
    />
  );
}
